import { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { motion, AnimatePresence } from 'motion/react';
import InstagramProfile from './InstagramProfile';
import Reviews from './Reviews';

import article1 from '../../assets/artical1.jpeg';
import article2 from '../../assets/artical2.jpeg';
import article3 from '../../assets/artical3.jpeg';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ease = [0.22, 1, 0.36, 1];

const articles = [
    { id: 1, image: article1 },
    { id: 2, image: article2 },
    { id: 3, image: article3 },
];

const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
                arrows: false,
                dots: true,
                autoplaySpeed: 3500,
            },
        },
    ],
};

export default function Articles() {
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        document.body.style.overflow = selectedImage ? 'hidden' : '';

        return () => {
            document.body.style.overflow = '';
        };
    }, [selectedImage]);

    return (
        <>
            <section className="w-full flex justify-center items-center bg-[#faf6ee] px-2 sm:px-6 lg:px-20 py-12 lg:py-16">
                <div className="w-full max-w-7xl">
                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7, ease }}
                        className="flex flex-col items-center text-center px-4 mb-8 lg:mb-10"
                    >
                        <p className="uppercase md:text-lg text-base font-extrabold text-brand-gold">
                            News & Articles
                        </p>

                        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-brand-forest mt-3 lg:mt-4">
                            Our Articles
                        </h2>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7, ease, delay: 0.15 }}
                    >
                        <Slider {...settings} className="articles-slider">
                            {articles.map((article) => (
                                <div key={article.id} className="px-2 sm:px-4 py-2">
                                    <motion.button
                                        type="button"
                                        onClick={() => setSelectedImage(article.image)}
                                        whileHover={{ y: -8 }}
                                        whileTap={{ scale: 0.98 }}
                                        className="group relative block w-full h-64 sm:h-72 lg:h-80 rounded-2xl overflow-hidden shadow-lg cursor-pointer p-0 border-0 bg-transparent"
                                    >
                                        <motion.img
                                            src={article.image}
                                            alt="Article"
                                            className="w-full h-full object-cover"
                                            whileHover={{ scale: 1.1 }}
                                            transition={{ duration: 0.7, ease }}
                                        />

                                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-500" />

                                        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            <span className="bg-white/90 text-[#064E3B] px-5 py-2.5 rounded-full text-sm font-semibold shadow-lg">
                                                View Article
                                            </span>
                                        </div>
                                    </motion.button>
                                </div>
                            ))}
                        </Slider>
                    </motion.div>
                </div>
            </section>

            <AnimatePresence>
                {selectedImage && (
                    <motion.div
                        className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 p-4"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3, ease }}
                        onClick={() => setSelectedImage(null)}
                    >
                        <motion.div
                            className="relative max-w-6xl w-full flex justify-center"
                            initial={{ opacity: 0, scale: 0.85, y: 20 }}
                            animate={{ opacity: 1, scale: 1, y: 0 }}
                            exit={{ opacity: 0, scale: 0.85, y: 20 }}
                            transition={{ duration: 0.45, ease }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <motion.button
                                type="button"
                                onClick={() => setSelectedImage(null)}
                                aria-label="Close image"
                                className="absolute top-[-45px] right-0 sm:top-[-20px] sm:right-[-20px] z-20 w-10 h-10 rounded-full bg-white text-black text-2xl font-bold flex items-center justify-center shadow-lg"
                                whileHover={{ scale: 1.1, rotate: 90 }}
                                whileTap={{ scale: 0.9 }}
                            >
                                ×
                            </motion.button>

                            <motion.img
                                src={selectedImage}
                                alt="Article preview"
                                className="max-w-full max-h-[85vh] object-contain rounded-xl shadow-2xl"
                                initial={{ scale: 0.9, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.5, ease }}
                            />
                        </motion.div>
                    </motion.div>
                )}

                <InstagramProfile />
                <div className='items-center bg-[#faf6ee] px-2 sm:px-6 lg:px-20 py-12 lg:py-16'>
                <Reviews />
                </div>
            </AnimatePresence>
        </>
    );
}